import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  JOB_SITE_OVERVIEWS_REFRESH: createSagaAction('JOB_SITE_OVERVIEWS_REFRESH'),

  JOB_SITE_OVERVIEW_CREATE: createSagaAction('JOB_SITE_OVERVIEW_CREATE'),
  JOB_SITE_OVERVIEW_UPDATE: createSagaAction('JOB_SITE_OVERVIEW_UPDATE'),
  JOB_SITE_OVERVIEW_DELETE: createSagaAction('JOB_SITE_OVERVIEW_DELETE')
}

// Action Creators
export const actions = {
  jobSiteOverviewsRefresh: ({ jobId }) => ({
    type: constants.JOB_SITE_OVERVIEWS_REFRESH.ACTION,
    jobId
  }),

  updateJobSiteNote: ({ jobId, userId, note }) => ({
    type: constants.JOB_SITE_OVERVIEW_UPDATE.ACTION,
    jobId,
    userId,
    note
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.JOB_SITE_OVERVIEWS_REFRESH.ACTION:
      return { ...state, error: null, loading: true }
    case constants.JOB_SITE_OVERVIEWS_REFRESH.SUCCESS:
      return {
        ...state,
        jobSiteOverviews: action.payload
      }
    case constants.JOB_SITE_OVERVIEWS_REFRESH.FAILED:
      return {
        error: action.message
      }
    case constants.JOB_SITE_OVERVIEW_UPDATE.SUCCESS:
      return {
        ...state
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/jobSiteOverviewActions.js